import {useState} from "react";
import {Button, TextField, Typography} from "@mui/material";
import {LoadingButton} from "@mui/lab";
import {Link, useNavigate} from "react-router-dom";
import BoxedLayout from "../../components/common/BoxedLayout";
import {useParams} from "react-router-dom";
import {forgotPasswordForm} from "../../schema/form";
import {useFormik} from "formik";
import * as yup from "yup";
import {requestNewPassword} from "../../services/dataService";
import {toast} from "react-toastify";

const ForgotPasswordSubmit = () => {
  let {email: userEmail} = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async (values) => {
    try {
      setLoading(true);
      await requestNewPassword({
        PassCode: values.PassCode,
        email: userEmail,
        newPassword: values.newPassword,
      });
      setLoading(false);
      navigate("/");
      toast.success("Password reset successful.");
    } catch (error) {
      setLoading(false);
      toast.error("Unable to update password");
    }
  };

  const userValidationSchema = yup.object({
    PassCode: yup.string().required("OTP can not be null"),
    newPassword: yup.string().required("Password is required"),
    confirmPassword: yup
      .string()
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });
  const formik = useFormik({
    initialValues: {
      PassCode: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: userValidationSchema,
    onSubmit: (values) => {
      handleResetPassword(values);
    },
  });

  return (
    <BoxedLayout>
      <Typography component="h1" variant="h5">
        Change your password
      </Typography>
      <Typography marginTop={3}>
        Enter the code you received by mail and choose a new password.
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        {forgotPasswordForm.map((current) => {
          return (
            <TextField
              margin="normal"
              fullWidth
              id={current.name}
              label={current.label}
              name={current.name}
              value={formik.values[current.name]}
              type={current.type}
              onChange={formik.handleChange}
              autoComplete='new-password'
              error={
                formik.touched[current.name] &&
                Boolean(formik.errors[current.name])
              }
              helperText={
                formik.touched[current.name] && formik.errors[current.name]
              }
            />
          );
        })}

        <LoadingButton
          type="submit"
          fullWidth
          size="large"
          variant="contained"
          color="primary"
          sx={{mt: 2}}
          loading={loading}
        >
          Reset password
        </LoadingButton>
      </form>
      <Button
        component={Link}
        to={`/login`}
        color="primary"
        fullWidth
        size="large"
        sx={{mt: 2}}
      >
        Back to login
      </Button>
    </BoxedLayout>
  );
};

export default ForgotPasswordSubmit;
